webpackJsonp([31,30],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(195);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vue = __webpack_require__(57);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(223);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	__webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.filter('date', function (date) {
	  var d = new Date(date);
	  var year = d.getFullYear();
	  var month = d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1);
	  var da = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
	  return year + '-' + month + '-' + da;
	});
	
	_vue2.default.filter('time', function (time) {
	  var t = parseInt(time / 1000 / 60);
	  return t + 'min';
	});
	_vue2.default.filter('timing', function (time) {
	  if (time >= 60000) {
	    var _t = parseInt(time / 1000 / 60);
	    var min = _t > 9 ? _t : '0' + _t;
	    var s = parseInt((time - _t * 60 * 1000) / 1000);
	    var sec = s > 9 ? s : '0' + s;
	    return min + ':' + sec;
	  } else {
	    var t = parseInt(time / 1000);
	    return '00:' + (t > 9 ? t : '0' + t);
	  }
	});
	_vue2.default.filter('filterRecord', function (value, arr, id) {
	  var brr = void 0;
	  brr = arr.filter(function (item) {
	    return item.student_id === id;
	  });
	  if (brr.length > 0) {
	    return '分数：' + brr[0].score + ' | 评语：' + brr[0].remark;
	  } else {
	    return false;
	  }
	});
	_vue2.default.filter('filterState', function (value) {
	  var brr = void 0;
	  brr = value.filter(function (item) {
	    return item.class_state === '筹备' || item.class_state === '进行';
	  });
	  if (brr.length > 0) {
	    return brr;
	  } else {
	    return false;
	  }
	});
	_vue2.default.filter('filterNav', function (arr) {
	  var brr = void 0;
	  if (window.localStorage.topxgun_training_userRole === '3') {
	    brr = arr.filter(function (item) {
	      return item.text !== '用户管理';
	    });
	  } else {
	    brr = arr;
	  }
	  return brr;
	});
	_router2.default.start(_App2.default, '#root');

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(57);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(224);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _config = __webpack_require__(10);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default();
	
	router.map({
	  '/login': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(210)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: false
	  },
	  '/s-login': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: false
	  },
	  '/s-info': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(216)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(56)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/user': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/user/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/teacher': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(218)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/teacher/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/student': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(56)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/student/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(215)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/record/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/record/:studentId': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(203)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/result/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/result/:studentId': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(204)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/cert/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/cert/:studentId': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/class/:id/student/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(205)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/doc': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(208)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/doc/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(209)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/course': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(206)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/course/:id/': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(207)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/course/:id/chapter/:chapterId': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(196)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/plane': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(211)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/plane/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(212)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/plane/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(213)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/practice': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(214)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/practice/add': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(55)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/practice/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(55)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '/practiceManager/:id': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  },
	  '3d': {
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(194)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    auth: true
	  }
	});
	
	router.beforeEach(function (transition) {
	  if (transition.to.auth) {
	    var storage = window.localStorage;
	    if (storage && storage.topxgun_training_token && storage.topxgun_training_userId && storage.topxgun_training_userRole || storage.topxgun_training_studentRole && storage.topxgun_training_studentToken && storage.topxgun_training_studentId) {
	      if (storage.topxgun_training_token && storage.topxgun_training_userId) {
	        _vue2.default.http.headers.common['token'] = window.localStorage.topxgun_training_token;
	        _vue2.default.http.headers.common['user_id'] = window.localStorage.topxgun_training_userId;
	        _vue2.default.http.post(_config2.default.API_URL + '/user/login').then(function (res) {
	          if (res.data.code === 0) {
	            if (window.localStorage.topxgun_training_userRole === '3' && transition.to.path === '/user') {
	              transition.redirect({ path: '/login' });
	            } else {
	              transition.next();
	            }
	          } else {
	            _vue2.default.http.headers.common['token'] = '';
	            _vue2.default.http.headers.common['user_id'] = '';
	            transition.redirect({ path: '/login' });
	          }
	        });
	      } else {
	        _vue2.default.http.headers.common['token'] = window.localStorage.topxgun_training_studentToken;
	        _vue2.default.http.headers.common['user_id'] = window.localStorage.topxgun_training_studentId;
	        _vue2.default.http.post(_config2.default.API_URL + '/student/login').then(function (res) {
	          if (res.data.code === 0) {
	            if (transition.to.path === '/s-info') {
	              transition.next();
	            } else if (transition.to.path === '/') {
	              transition.redirect({ path: '/s-info' });
	            } else {
	              transition.redirect({ path: '/s-login' });
	            }
	          } else {
	            _vue2.default.http.headers.common['token'] = '';
	            _vue2.default.http.headers.common['user_id'] = '';
	            transition.redirect({ path: '/s-login' });
	          }
	        });
	      }
	    } else {
	      _vue2.default.http.headers.common['token'] = '';
	      _vue2.default.http.headers.common['user_id'] = '';
	      transition.redirect({ path: '/login' });
	    }
	  } else {
	    _vue2.default.http.headers.common['token'] = '';
	    _vue2.default.http.headers.common['user_id'] = '';
	    transition.next();
	  }
	});
	
	exports.default = router;

/***/ },

/***/ 10:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var constant = {
	  API_URL: 'http://139.196.178.191:8080',
	  socketHost: 'https://data.topxgun.com:61234'
	};
	exports.default = constant;

/***/ },

/***/ 58:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  ready: function ready() {
	    var _this = this;
	
	    window.check = function (settings, cb) {
	      _this.show = true;
	      _this.aboveText = settings.aboveText ? settings.aboveText : '';
	      _this.belowText = settings.belowText ? settings.belowText : '';
	      _this.content = settings.content ? settings.content : '';
	      _this.contentPlaceholder = settings.contentPlaceholder ? settings.contentPlaceholder : '';
	      _this.text = settings.text ? settings.text : '';
	      _this.textPlaceholder = settings.textPlaceholder ? settings.textPlaceholder : '';
	      _this.cb = cb;
	    };
	  },
	  data: function data() {
	    return {
	      show: false,
	      aboveText: '',
	      belowText: '',
	      content: '',
	      error: '',
	      text: '',
	      textPlaceholder: '',
	      contentPlaceholder: '',
	      cb: function cb() {}
	    };
	  },
	
	  methods: {
	    confirm: function confirm() {
	      var _this2 = this;
	
	      if (this.content === '' && this.contentPlaceholder) {
	        this.error = this.contentPlaceholder + '不能为空';
	      } else if (this.text === '' && this.textPlaceholder) {
	        this.error = this.textPlaceholder + '不能为空';
	      } else {
	        var obj = { content: this.content, text: this.text };
	        this.cb(true, function () {
	          _this2.init();
	        }, obj);
	      }
	    },
	    cancel: function cancel() {
	      var _this3 = this;
	
	      this.error = '';
	      this.cb(false, function () {
	        _this3.init();
	      });
	    },
	    init: function init() {
	      this.show = false;
	      this.aboveText = '';
	      this.belowText = '';
	      this.cb = null;
	    }
	  }
	};

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Check = __webpack_require__(193);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Check: _Check2.default
	  }
	};

/***/ },

/***/ 123:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 132:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 155:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 161:
/***/ function(module, exports) {

	module.exports = " <div> <router-view></router-view> <check></check> </div> ";

/***/ },

/***/ 170:
/***/ function(module, exports) {

	module.exports = " <div v-show=show _v-3aa13638=\"\"> <div class=bg _v-3aa13638=\"\"></div> <div :class=\"['content',(textPlaceholder&amp;&amp;contentPlaceholder)?'height360':(contentPlaceholder?'height300':'height229')]\" _v-3aa13638=\"\"> <div class=img _v-3aa13638=\"\"></div> <div class=text _v-3aa13638=\"\"> {{aboveText}} </div> <div class=text _v-3aa13638=\"\"> {{belowText}} </div> <div v-show=contentPlaceholder _v-3aa13638=\"\"> <input type=text class=textBorder v-model=content placeholder={{contentPlaceholder}} _v-3aa13638=\"\"> </div> <div v-show=textPlaceholder _v-3aa13638=\"\"> <input type=text class=textBorder v-model=text placeholder={{textPlaceholder}} _v-3aa13638=\"\"> </div> <div class=errorMsg v-show=contentPlaceholder _v-3aa13638=\"\">{{error}}</div> <div class=group _v-3aa13638=\"\"> <div class=\"confirm acbtn\" @click=confirm _v-3aa13638=\"\"> 确定 </div> <div class=\"cancel acbtn\" @click=cancel _v-3aa13638=\"\"> 取消 </div> </div> </div> </div> ";

/***/ },

/***/ 193:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(132)
	__vue_script__ = __webpack_require__(58)
	__vue_template__ = __webpack_require__(170)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },

/***/ 195:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(123)
	__vue_script__ = __webpack_require__(60)
	__vue_template__ = __webpack_require__(161)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.c4b0eaa00ced2c56a7d1.js
 **/